const TRHeader = ({ children }) => {
  return <tr className="bg-gray-50">{children}</tr>;
};

export default TRHeader;
